import React from "react";
import { Tooltip, withStyles } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";

const MUITooltip = withStyles((theme) => ({
  tooltip: {
    display: "flex",
    flexDirection: "column",
    padding: theme.spacing(3),
    borderRadius: theme.spacing(2),
    backgroundColor:
      theme.palette.type === "light"
        ? theme.palette.secondary.main
        : theme.palette.secondary.tint60,
    color: theme.palette.white.qrCode,
  },
  tooltipPlacementLeft: {
    transformOrigin: "right center",
  },
}))(Tooltip);
const CustomTooltip = (props) => {
  const { children, title, placement } = props;

  return (
    <MUITooltip title={title} placement={placement} arrow="true">
      {children}
    </MUITooltip>
  );
};

export default CustomTooltip;
